export { Desktop } from './desktop.component';
